import { render } from "./Lots.vue?vue&type=template&id=07c40dc7"
import script from "./Lots.vue?vue&type=script&lang=js"
export * from "./Lots.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Storage/Development/VintageTradingPost/auction-system/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__